import styled from 'styled-components';
import { theme } from '@octane/spark';

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const Title = styled.h1`
  font-family: 'Oswald', sans-serif;
  font-weight: 700;
  font-size: 24px;
  line-height: 30px;
  text-align: center;
  margin: 0;
  color: ${({ theme }) => theme.colors.monochrome.jetlineBlack};
`;

export const Subtitle = styled.h2`
  ${theme.fonts.Karla['s18-ln24-fw400']};
  margin: 0;
  text-align: center;
  color: ${({ theme }) => theme.colors.monochrome.asphalt};
`;
